
mainApp.component('statThreshold', {
    templateUrl: '/public/directives/stat-threshold.component.html',
    bindings: {
        caption: '@',
        model: '<',
        changeListener: '&',
        errors: "=",
        isDisabled: '='
    },
    controller: statThresholdController
});

function statThresholdController($scope) {
    var ctrl = this;

    ctrl.$onInit = function() {
        // innerChange is required to manage and distinct between a change that happen from within the component and outside of it
        // the use case is that while navigating between same page that includes the component we want the value to be updated (including
        // the checkbox) while in cases where the value changed from within the component without navigation, the checkbox should not
        // be updated - without this flag deletion of the input value will also clear the checkbox.
        ctrl.innerChange = false;
        ctrl.assignModel();
    }

    ctrl.$onChanges = function(changes) {
        if (ctrl.innerChange) {
            ctrl.innerChange = false;
            return;
        }

        if (changes['model'])
            ctrl.assignModel();
    }

    ctrl.assignModel = function() {
        if (ctrl.model) {
            ctrl.enabled = true;
            ctrl.value = ctrl.model;
        } else {
            ctrl.enabled = false;
            ctrl.value = null;
        }
    }

    ctrl.toggle = function() {
        if (ctrl.enabled) {
            ctrl.value = 1;
            ctrl.model = ctrl.value;
        } else {
            ctrl.value = null;
            ctrl.model = null;
        }
        ctrl.change();
    }

    ctrl.change = function() {
        ctrl.innerChange = true;
        ctrl.changeListener({value: ctrl.value});
    }
};

